export const parseCalculatorData = data => {
  const parsedBlogPosts = {guide:[], others:[]};
  const postsListGuide = [];
  const postsListOthers = [];

  const parsePostItem = ({item, list}) => (
    {
      list,
      picture: {
        src: item.featuredImage?.url,
        alt: item.shortHeading
      },
      url: `/pl/${item.category?.slug}/${item.slug}`,
      heading: item.shortHeading,
      description: item.shortContent
    }
  );

  const parseProductItem = item => {
    if (typeof (item) === 'string') return null;

    return {
      picture: {
        src: item.image?.url,
        alt: item.productName,
      },
      url: `${item.buttonLink ? item.buttonLink : item.buttonLabel}`,
      heading: item.productName,
      description: item?.text?.content
    }
  };

   const productList = (data?.productsToDisplay || [])
      .map(parseProductItem)
      .filter(Boolean);

  if (data?.postsToDisplay) {
    data.postsToDisplay.forEach(
      ({ post, list }) => {

        const parsedItem = parsePostItem({item:post, list})

        switch (list) {
          case 0:
            postsListGuide.push(parsedItem)
            break;
          case 1:
            postsListOthers.push(parsedItem)
            break;
          default: return;
        }
      }
    )

    parsedBlogPosts.guide = postsListGuide;
    parsedBlogPosts.others = postsListOthers;
  }

 return  ({
   heading: data.heading,
   description: data.description,
   badge: data.badge,
   step1: {
    ...data.step1
   },
   step2: {
     ...data.step2
   },
   step3: data.step3,
   postsToDisplay: parsedBlogPosts,
   productsToDisplay: productList
  })
};
